import { DotsVerticalCircleIcon } from './DotsVerticalCircleIcon';

/**
 * author: Austin Andrews
 * id 5D23E65D-271A-463B-972F-E8524E76E6D7
 * name dots-vertical-circle
 * version: 2.0.46
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dots-vertical-circle.svg
 * tags
 */
export const EllipsisVerticalCircleIcon = DotsVerticalCircleIcon;
export default EllipsisVerticalCircleIcon